import Header from "../Header";

function $1(props) {
    return (
        <>
            <Header title="News Feed" />
        <div className="container-scroller">
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className="container">
                        <div className="row" data-aos="fade-up">
                            <div className="col-lg-3 stretch-card grid-margin">
                                <div className="card">
                                    <div className="card-body">
                                        <h2>Category</h2>
                                        <ul className="vertical-menu">
                                            <li><a href="#">CDSS Ontology</a></li>
                                            <li><a href="#" className="disabled">CDSS Modules</a></li>
                                            <li><a href="#" className="disabled">AI/ML</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 stretch-card grid-margin">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-4 grid-margin">
                                                <div className="position-relative">
                                                    <div className="rotate-img">
                                                        <img alt="thumb" className="img-fluid" src="assets/pages/home/carousel_1.jpg"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-8  grid-margin">
                                                <h5 className="mb-2 font-weight-600">
                                                    Development, validation, and application of a CDS ontology to facilitate CDS
                                                    rules reuse, management, and maintenance in simulated primary care settings.
                                                </h5>
                                                <div className="fs-13 mb-2">
                                                    <span className="mr-2">Authors </span><a href="#">Dr. Xia Jing (Clemson
                                                    University)</a>
                                                </div>
                                                <p className="mb-0">
                                                    The proposed investigation will develop publicly accessible, reusable,
                                                    upper-level clinical decision support (CDS) ontology and
                                                    machine-interpretable CDS rules for CDC-recommended immunization schedules,
                                                    which
                                                    will save duplicate effort by multiple stakeholders of CDS rules and build a
                                                    critical foundation for achieving interoperability for individuals’
                                                    immunization records. Our investigation also aims to enable primary care
                                                    providers, especially in small primary care practices, to manage and
                                                    maintain CDS rules independently to keep CDS updated, useful, and working to
                                                    its full potential and to benefit the large population served by such
                                                    practices. This investigation has the potential to provide more consistent
                                                    preventive services and improve CDC-recommended immunization rates in
                                                    primary care settings.
                                                </p>
                                            </div>
                                        </div>
                                        <br/>
                                        <div className="row">
                                            <div className="col-sm-4 grid-margin">
                                                <div className="position-relative">
                                                    <div className="rotate-img">
                                                        <img alt="thumb" className="img-fluid" src="assets/pages/home/carousel_1.jpg"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-8  grid-margin">
                                                <h5 className="mb-2 font-weight-600">
                                                    Project 2
                                                </h5>
                                                <div className="fs-13 mb-2">
                                                    <span className="mr-2">Authors </span><a href="#">Dr. Xia Jing (Clemson
                                                    University)</a>
                                                </div>
                                                <p className="mb-0">
                                                    The proposed investigation will develop publicly accessible, reusable,
                                                    upper-level clinical decision support (CDS) ontology and
                                                    machine-interpretable CDS rules for CDC-recommended immunization schedules,
                                                    which
                                                    will save duplicate effort by multiple stakeholders of CDS rules and build a
                                                    critical foundation for achieving interoperability for individuals’
                                                    immunization records
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" data-aos="fade-up">
                            <div className="col-sm-12 grid-margin">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-8">
                                                <div className="card-title">
                                                    Video
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 grid-margin">
                                                        <div className="position-relative">
                                                            <div className="rotate-img">
                                                                <iframe src="https://www.youtube.com/embed/QCKhJ3mQRts"
                                                                        title="YouTube video player" frameBorder="0"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        allowFullScreen></iframe>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-6 grid-margin">
                                                        <div className="position-relative">
                                                            <div className="rotate-img">
                                                                <iframe src="https://www.youtube.com/embed/nB05_QbPS0A"
                                                                        title="YouTube video player" frameBorder="0"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        allowFullScreen></iframe>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 grid-margin">
                                                        <div className="position-relative">
                                                            <div className="rotate-img">
                                                                <iframe src="https://www.youtube.com/embed/jfUPLuPL3Ho"
                                                                        title="YouTube video player" frameBorder="0"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        allowFullScreen></iframe>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-6 grid-margin">
                                                        <div className="position-relative">
                                                            <div className="rotate-img">
                                                                <iframe src="https://www.youtube.com/embed/mft0wovlsOI"
                                                                        title="YouTube video player" frameBorder="0"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        allowFullScreen></iframe>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="card-title">
                                                        Latest Video
                                                    </div>
                                                    <a href="" className="mb-3">Check playlist</a>
                                                </div>
                                                <div
                                                    className="d-flex justify-content-between align-items-center border-bottom pb-2">
                                                    <div className="div-w-80 mr-3">
                                                        <div className="rotate-img">
                                                            <img alt="thumb" style={{height:"150px", width:"250px"}} className="img-fluid" src="assets/pages/home/carousel_1.jpg"/>
                                                        </div>
                                                    </div>
                                                    <h3 className="font-weight-600 mb-0"> Video link 1 </h3>
                                                </div>
                                                <div
                                                    className="d-flex justify-content-between align-items-center border-bottom pt-3 pb-2">
                                                    <div className="div-w-80 mr-3">
                                                        <div className="rotate-img">
                                                            <img alt="thumb" style={{height:"150px", width:"250px"}} className="img-fluid" src="assets/pages/home/carousel_1.jpg"/>
                                                        </div>
                                                    </div>
                                                    <h3 className="font-weight-600 mb-0"> Video link 2 </h3>
                                                </div>
                                                <div
                                                    className="d-flex justify-content-between align-items-center border-bottom pt-3 pb-2">
                                                    <div className="div-w-80 mr-3">
                                                        <div className="rotate-img">
                                                            <img alt="thumb" style={{height:"150px", width:"250px"}} className="img-fluid" src="assets/pages/home/carousel_1.jpg"/>
                                                        </div>
                                                    </div>
                                                    <h3 className="font-weight-600 mb-0"> Video link 3 </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default $1;